import { ca } from '@cian/analytics';
import { TCategories } from '../../types/analytics';

interface ITrackCategoriesClick {
  type: TCategories;
  searchConditions: string;
}

export function trackClickCategories({ type, searchConditions }: ITrackCategoriesClick) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'Click',
    label: type,
    sc: searchConditions,
  });
}
